import {genericMapper} from "./stringUtils";

export function operatorStatusMapper(status: string): string {
    const mapping: any = {
        CREATED: 'Active',
        NOT_CREATED: 'Disabled'
    }

    return mapping[status] || genericMapper(status)
}